module.exports = __webpack_public_path__ + "img/KrishifyChat.66d25e65.svg";